import Vue from 'vue';
import subscriberListTransformer from './../../transformers/subscriberList';


const success = (data, resolve) => {
  Vue.router.push({
    name: 'subscriberList.edit',
    params: { id: data.id },
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(subscriberListTransformer.fetch(errors));
};

export default subscriberList => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('subscriberList', subscriberList)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriberList/store.js